<script>
  import LoginPanel from '../components/LoginPanel.svelte';
  function done() { document.dispatchEvent(new CustomEvent('navigate', { detail: 'home' })); }
</script>
<div class="login-page"><LoginPanel on:success={done} /></div>
<style>.login-page { max-width: 440px; margin: 40px auto; padding: 20px; border: 1px solid #8883; border-radius: 20px; }</style>
